'use strict'

import $ from 'jquery';
import { isMobile, CLASS_ACTIVE } from './helpers';

const decades = {

  _showOnlinePreviews: function (data) {
    const getTimeLineYear = (url) => {
      if (url) {
        const matches = new RegExp(data.timelinePage + '([0-9]{4})/?', 'g').exec(url);
        return matches ? (parseInt(matches[1]) || false) : false;
      }

      return false;
    };

    const createPreviewElement = (year) => {
      if (!data.previews[year]) {
        return null;
      }

      const img = document.createElement('img');
      img.src = data.previews[year];
      img.alt = '';

      const div = document.createElement('div');
      div.classList.add('online-preview');
      div.appendChild(img);

      return div;
    };

    const handleMouseOver = (e) => {
      const previewState = e.target.getAttribute('data-online-preview');
      if (!isMobile() && previewState && previewState === 'hidden') {
        // Show preview
        e.target.setAttribute('data-online-preview', 'visible');

        // Recalculate preview position
        const containerRect = e.target.closest('.decade-description').getBoundingClientRect();
        const rect = e.target.getBoundingClientRect();
        const previewWidth = 480;
        const overflowRight = 30;
        const overflowTop = 16;
        let left = rect.width - overflowRight;
        const lines = Math.floor((e.target.offsetLeft + rect.width) / containerRect.width);
        left = (e.target.offsetLeft + rect.width) - (lines * containerRect.width) - e.target.offsetLeft - overflowRight;

        // Decrease left position if preview does not fit in window
        const maxX = previewWidth + containerRect.x + e.target.offsetLeft + left + overflowRight;
        if (maxX > window.innerWidth) {
          left -= maxX - window.innerWidth;
        }

        // Update preview position
        const preview = e.target.querySelector('.online-preview');
        preview.style.left = left + 'px';
        preview.style.top = (rect.height - overflowTop) + 'px';
      }
    };

    const handleMouseLeave = (e) => {
      const previewState = e.target.getAttribute('data-online-preview');
      if (previewState && previewState === 'visible') {
        e.target.setAttribute('data-online-preview', 'hidden');
      }
    };

    const handleMouseClick = (e) => {
      if (!isMobile()) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    const yearLinks = document.querySelectorAll('.decade-description a');
    Array.from(yearLinks).forEach(link => {
      const year = getTimeLineYear(link.href);
      if (year) {
        const previewElement = createPreviewElement(year);
        link.setAttribute('data-online-preview', 'hidden');
        link.appendChild(previewElement);
        link.addEventListener('mouseover', handleMouseOver);
        link.addEventListener('mouseleave', handleMouseLeave);
        link.addEventListener('click', handleMouseClick);
      }
    });

    document.body.addEventListener('touchstart', () => {
      const visiblePreview = document.querySelector('[data-online-preview="visible"]');
      if (visiblePreview) {
        handleMouseLeave({ target: visiblePreview });
      }
    });
  },

  _hideTabInMobile: function (animate) {
    const $active = $('.decade.active');
    const $button = $active.prev();

    if (animate) {
      $('body, html').animate({
        scrollTop: $button.offset().top - 120
      }, 300, function() {
        $active.height($active.height());
        $active.addClass('animating');
        setTimeout(() => {
          $active.height(0);
        });

        setTimeout(() => {
          $active.removeClass('animating active show');
          $active.removeAttr('style');
          $button.removeClass('active-decade');
        }, 500);
      });
    }
    else {
      $active.removeClass('animating active show');
      $button.removeClass('active-decade');
    }
  },

  _animateOpenInMobile: function ($tab, $buttonContainer) {
    const $content = $('#' + $tab.attr('aria-controls'));
    const height = $content.height();
    $content.addClass('animating');

    setTimeout(() => {
      $content.height(height);
    }, 10);

    setTimeout(() => {
      $('body, html').animate({
        scrollTop: $buttonContainer.offset().top - 120
      }, 300);
    }, 100);

    setTimeout(() => {
      $content.removeClass('animating').removeAttr('style');
    }, 500);
  },

  /**
   * Registers on click event for tab link.
   */
  registerTabOnClickEvent: function () {
    const originalHref = document.querySelector('.decades').dataset.originalHref;
    $('.nav-link').on('click', function () {
      // SAMPOTEST-107 Update url on click of tab link
      const decade = this.dataset.decade;
      const url = `${originalHref}${decade}/`;
      history.pushState({}, decade, url);
    });
  },

  init: function () {

    if (document.body.classList.contains('did-you-know')) {

      // SAMPOTEST-107 Hide tab in mobile if page is not loaded with decade in url.
      if (isMobile() && typeof document.querySelector('.decades').dataset.onPageLoadDecade === 'undefined') {
        this._hideTabInMobile();
      }

      const self = this;
      setTimeout(() => {
        $('.decades').addClass('initialized');
      }, 200);

      // Trigger tab when mobile toggle button is clicked
      $('.decade-button').on('click', function () {
        const $button = $(this);
        const $parent = $button.closest('.decade-mobile-toggle');
        const $tab = $('#' + $button.attr('data-tab'));
        if ($parent.hasClass('animating')) {
          return;
        }

        let mobileReOpen = false;
        if ($tab.attr('aria-selected') === 'true') {
          if ($parent.hasClass('active-decade')) {
            self._hideTabInMobile(true);
            return;
          }
          else {
            mobileReOpen = true;
          }
        }

        $('.decade-mobile-toggle').removeClass('animating');
        $parent.addClass('animating');
        setTimeout(() => {
          $parent.removeClass('animating');
          if (mobileReOpen) {
            $parent.addClass('active-decade');
            $('#' + $tab.attr('aria-controls')).addClass('active show');
            self._animateOpenInMobile($tab, $parent);
          }
          else {
            $tab.click();
          }
        }, 300);
      });

      $('.decade-close').on('click', function () {
        self._hideTabInMobile(true);
      });

      // Change active mobile toggle button and animate tab content on mobile
      $('.decade-list [data-toggle="tab"]').on('shown.bs.tab', function () {
        const $toggles = $('.decade-mobile-toggle');
        const $toggle = $toggles.filter('[data-decade="' + this.getAttribute('data-decade') + '"]');

        $toggles.removeClass('active-decade');
        $toggle.addClass('active-decade');

        if (isMobile()) {
          self._animateOpenInMobile($(this), $toggle);
        }
      });

      // Remove/add bootstrap tab-pane animate class
      const toggleTabAnimation = () => {
        if (isMobile()) {
          $('.decade').removeClass('fade');
        } else {
          
          // SAMPOTEST-108 Open first decade when mobile view has no decade open and moving from portrait to landscape view.
          // Get active tab
          const activeDecade = document.querySelector('.decade.active');
          // If no active decade found
          if (activeDecade === null) {
            // Set first element to active 
            document.querySelector('.decade').classList.add(CLASS_ACTIVE);
          }

          // Add fade class only to hidden tab content elements not to active element
          $('.decade:not(.active)').addClass('fade');
        }
      };
      toggleTabAnimation();
      $(window).resize(toggleTabAnimation);

      if (window.sampoOnlinePreviews) {
        this._showOnlinePreviews(window.sampoOnlinePreviews);
      }

      // SAMPOTEST-107 These functions handles hash changes so user can navigate decades with back and redo buttons.
      this.registerTabOnClickEvent();
    }
  }
}

module.exports = decades;
